export default "__VITE_PUBLIC_ASSET__053404f8__"